import { ForgeProjectSection } from "./SDKForgeProjectSection";
export class ForgeProjectDocumentSection extends ForgeProjectSection {
    constructor(model) {
        super(model);
        this.childType = "Artifact";
    }
}
